export default __webpack_public_path__ + "static/media/2-Ano-02-Para-Onde-Eu-Vou.b1f26ccd.png";